import { EventContextProvider, useAnalytics } from "@codat/analytics";
import { SquareNewWindowIcon } from "@codat/orchard-ui";
import { useFeatureStatus } from "portal-ui-remote/FeatureStatusContext";
import React, { useEffect } from "react";

import Button from "components/Button";
import Page from "components/Page";
import PageHeader from "components/PageHeader";
import { SvixEmbed } from "components/SvixEmbed";

import { LegacyWebhookEvents } from "./LegacyWebhookEvents";
import styles from "./WebhookEvents.module.scss";

const WebhookEvents = () => {
  const { featureStatus } = useFeatureStatus();
  const { sendPageViewEvent } = useAnalytics();

  const isUsingNewWebhooks = featureStatus?.["Rules.UseNewWebhooks"] ?? false;

  useEffect(() => {
    sendPageViewEvent("Webhook Events");
  }, [sendPageViewEvent]);

  return (
    <Page>
      <EventContextProvider name="Webhook Events">
        {isUsingNewWebhooks ? (
          <>
            <PageHeader header="Webhook events">
              <Button
                buttonName="Webhook Docs"
                href="https://docs.codat.io/using-the-api/webhooks/overview"
                target="_blank"
                color="interface"
                variant="secondary"
                aria-label="Webhook docs"
                data-testid="webhook-docs-button"
              >
                Webhook docs
                <SquareNewWindowIcon className={styles.extBtnIcon} />
              </Button>
            </PageHeader>

            <SvixEmbed />
          </>
        ) : (
          <LegacyWebhookEvents />
        )}
      </EventContextProvider>
    </Page>
  );
};

export default WebhookEvents;
